export const Code500 = "Ocurrio un problema al realizar su solicitud";
export const MesaggeWarning = "No se encontraron los datos proporcionados por los filtros"
export const MesaggeDanger = "Ocurrio un problema"